export const changeCard = (card) => ({
  type: "CHANGE_CARD", 
  payload: card
});


// WEBPACK FOOTER //
// ./src/actions/cardAction.js